import { render, staticRenderFns } from "./AboutPrivate.vue?vue&type=template&id=7f997ecf&scoped=true&"
import script from "./AboutPrivate.vue?vue&type=script&lang=js&"
export * from "./AboutPrivate.vue?vue&type=script&lang=js&"
import style0 from "./AboutPrivate.vue?vue&type=style&index=0&id=7f997ecf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f997ecf",
  null
  
)

export default component.exports